// extracted by mini-css-extract-plugin
export default {"root":"A97FcEjRM6"};